import React from 'react';
import Link from "next/link";

const AddItems = ({t}) => {

    const add_items = t('common:add_items', {}, {returnObjects: true});

    return (
        <section className={'add_items'}>
            <div className="container">
                <ul className="add_items_list">
                    {add_items.map(el => {
                        return <li key={el.icon} className={'add_item'}>
                            <Link className={'add_item_wrapper'} href={el.url}>
                                <img width={164} height={164} className={'add_item_icon'} src={`/img/commons/addItems/${el.icon}.png`} alt={el.title}/>
                                <h3 className={'add_item_title'}>{el.title}</h3>
                            </Link>
                        </li>
                    })}
                </ul>
            </div>
        </section>
    );
};

export default AddItems;